import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'amTimeAgo',
    pure: true,
    standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
    transform (
        value: string | Date,
        curTime: Date,
    ): string {
        if (!value) {
            return '';
        }

        let startTime: Date;
        if (typeof value === 'string') {
            startTime = new Date(value);
        } else {
            startTime = value;
        }

        return moment(startTime).from(moment(curTime));
    }
}
